import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAnswersList } from '../../../reducers/questionnaire';
import { requestFetchQuestionnaireAnswers } from '../../../actions/questionnaire';
import Information from '../../../components/Pages/Profile/Information';

const mapStateToProps = (state) => {
  return {
    answers: getAnswersList(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestFetchQuestionnaireAnswers,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Information);
